<template>
  <div class="py-1">
    <div class="h-px aha-storybook-dropdown-divider" />
  </div>
</template>

<script>
export default {
  name: 'DropdownDivider',
}
</script>
<style>
.aha-storybook-dropdown-divider {
  background-color:#EBEBEB
}
</style>
